import "./Footer.css";

const Footer = () => {
  return (
    <footer className="user-footer">
      <div>
        Designed by <strong>Kognitycs</strong>
      </div>

      <div>
        <a
          href="https://kognitycs.com/about-us/"
          target="_blank"
          rel="noopener noreferrer"
        >
          About Kognitycs
        </a>
      </div>

      <div>
        <a
          href="https://kognitycs.com/contact-us/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Contact Us
        </a>
      </div>
    </footer>
  );
};

export default Footer;
